/** Key written by Audience View: '1' when that window is focused (should own deck audio), else '0'. */
export const AUDIENCE_AUDIO_FOCUS_KEY = 'deckpack-audience-has-focus';

export function readAudienceAudioFocusFromStorage() {
  try {
    const v = localStorage.getItem(AUDIENCE_AUDIO_FOCUS_KEY);
    if (v === '0') return false;
    return true;
  } catch {
    return true;
  }
}

export function writeAudienceAudioFocusToStorage(focused) {
  try {
    localStorage.setItem(AUDIENCE_AUDIO_FOCUS_KEY, focused ? '1' : '0');
  } catch {
    /* ignore */
  }
}
